export function previewPackageRoot(bundleId: string): string {
  return `preview-packages/${bundleId}`;
}
